import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import layouts from '../layouts';
import WelcomeBanner from '../components/WelcomeBanner';
import DriverHomeMobile from './DriverHomeMobile';
import { useIsMobile } from '../../mobile';
import DashboardGrid from '../components/DashboardGrid';
import MyWorkTile from '../tiles/MyWorkTile';
import LeaderboardMiniTile from '../tiles/LeaderboardMiniTile';
import StatCardTile from '../tiles/StatCardTile';
import DispatchQueueTile from '../tiles/DispatchQueueTile';
import ComplianceExpirationTile from '../tiles/ComplianceExpirationTile';
import StipendUsageTile from '../tiles/StipendUsageTile';
import RequestsBucketsTile from '../tiles/RequestsBucketsTile';
import PositionWorkflowBucketTile from '../tiles/PositionWorkflowBucketTile';
import SignRequestsPlaceholderTile from '../tiles/SignRequestsPlaceholderTile';
import TaggingRequestsPlaceholderTile from '../tiles/TaggingRequestsPlaceholderTile';
import ShiftPickupTile from '../tiles/ShiftPickupTile';
import '../Dashboard.css';

/**
 * Tile registry — string key in the layout descriptor → React component.
 * All tile types register here. Layout descriptor references these keys.
 */
const TILE_REGISTRY = {
  MyWork: MyWorkTile,
  LeaderboardMini: LeaderboardMiniTile,
  StatCard: StatCardTile,
  DispatchQueue: DispatchQueueTile,
  ComplianceExpiration: ComplianceExpirationTile,
  StipendUsage: StipendUsageTile,
  RequestsBuckets: RequestsBucketsTile,
  PositionWorkflowBucket: PositionWorkflowBucketTile,
  SignRequestsPlaceholder: SignRequestsPlaceholderTile,
  TaggingRequestsPlaceholder: TaggingRequestsPlaceholderTile,
  ShiftPickup: ShiftPickupTile,
};

export default function DashboardPage() {
  const { user, dashboardRole } = useAuth();
  const location = useLocation();
  const isMobile = useIsMobile();

  // Dev-only role override for layout QA (e.g. /?as=driver). Disabled in prod.
  let role = dashboardRole;
  if (process.env.NODE_ENV !== 'production') {
    const override = new URLSearchParams(location.search).get('as');
    if (override && layouts[override]) role = override;
  }

  const layout = layouts[role] || layouts.default;

  // Drivers live on the phone: their home is a purpose-built screen, not
  // the 12-column tile grid squeezed to 375px.
  if (isMobile && role === 'driver') {
    return <div className="dash-page" style={{ padding: 0 }}><DriverHomeMobile user={user} /></div>;
  }

  return (
    <div className="dash-page">
      <WelcomeBanner user={user} kpiKeys={layout.welcomeKpis} />
      <DashboardGrid rows={layout.rows} tileRegistry={TILE_REGISTRY} />
    </div>
  );
}
